import { render, staticRenderFns } from "./indicator-form-tab4.vue?vue&type=template&id=db41fbfe&scoped=true&"
import script from "./indicator-form-tab4.vue?vue&type=script&lang=ts&"
export * from "./indicator-form-tab4.vue?vue&type=script&lang=ts&"
import style0 from "./indicator-form-tab4.vue?vue&type=style&index=0&id=db41fbfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db41fbfe",
  null
  
)

export default component.exports